export default __webpack_public_path__ + "static/media/sharedCulture.2ca9b3fc.webp";